import { ReactElement } from "react";
import Modify from "@shared/FormTemplates/Modify";
import ModifyForm from "./ModifyForm";
import updateItem from "@services/Core/ClientManager/updateClient";
import useGetDetailItem from "@hooks/Security/Clients/useGetClient";
import validator from "@validators/Security/Clients/client.validate";
import formMapper from "@mappers/Security/Clients/Client.mapper";

const ModifyItem = (): ReactElement => (
  <Modify
    CustomForm={ModifyForm}
    modifyHook={updateItem}
    detailHook={useGetDetailItem}
    validator={validator}
    formMapper={formMapper}
  />
);

export default ModifyItem;
